import { FixedNumber } from '@ethersproject/bignumber'

export const FIXED_0 = FixedNumber.from(0)
export const FIXED_1 = FixedNumber.from(1)
export const FIXED_2 = FixedNumber.from(2)
